<template>
  <vs-row vs-justify="center" id="statistics-box">
      <vs-card id="form">
          <div :style="{'justify-content': $i18n.locale === 'ar' ? 'right' : 'left'}" style=";display: flex;padding-bottom: 20px">
            <vs-select
                style="margin-right: 20px;width:25%"
                v-model="filterType"
                @change="loadServiceTime = true"
            >
              <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="$t('Statistics.'+item.value)"
                  v-for="(item, index) in filterOptions"
              />
            </vs-select>
            <date-picker @change="changeFilterRanged" :range="true" :disabledDate="disableDates" :clearable="false" v-model="dateRange" :type="'month'" valueType="format"></date-picker>
          </div>
      </vs-card>

          <SmallStatBox :icon="'mdi-ticket'" :title="$t('Statistics.Tabs.totalTicket')" :isMinutes="false" :data="totalTickets"></SmallStatBox>
          <SmallStatBox :icon="'mdi-square-inc'" :title="$t('Statistics.Tabs.totalService')" :isMinutes="false" :data="totalServices"></SmallStatBox>
          <SmallStatBox :icon="'mdi-book-open'" :title="$t('Statistics.Tabs.totalRdv')" :isMinutes="false" :data="totalRdv"></SmallStatBox>
          <SmallStatBox :icon="'mdi-clock'" :title="$t('Statistics.Tabs.avgWaitingTime')" :isMinutes="true" :data="avgWaitingTime"></SmallStatBox>
          <SmallStatBox :icon="'mdi-clock'" :title="$t('Statistics.Tabs.avgTimeSpent')" :isMinutes="true" :data="avgTimeSpent"></SmallStatBox>
          <SmallStatBox :icon="'mdi-send'" :title="$t('Statistics.Tabs.totalSms')" :isMinutes="false" :data="totalSms"></SmallStatBox>

          <WaitingServiceTime :headerTitle="$t('Statistics.Tabs.Time.Title')" :showFilter="false" @doneLoading="loadServiceTime = false, loadFrequencyCharts = true" :isRange="false" :start-loading="loadServiceTime" :date-range="dateRange" :waitingServiceTimeParams="{periodical : filterType}" />
          <FrequencyCharts :headerTitle="$t('Statistics.Tabs.Frequency.Title')" :showFilter="false" @doneLoading="loadFrequencyCharts = false, loadServicePieChart = true" :start-loading="loadFrequencyCharts" :isRange="false" :date-range="dateRange" :visitFrequencyParams="{periodical : filterType}" />

          <ServicePieChart :dateRange="dateRange" @doneLoading="loadServicePieChart = false, loadServiceFrequency = true" :start-loading="loadServicePieChart" :headerTitle="$t('Statistics.ServiceFrequency.ServicesPie')" />
          <ServiceFrequency :dateRange="dateRange" @doneLoading="loadServiceFrequency = false, loadHourPeak = true" :start-loading="loadServiceFrequency" :headerTitle="$t('Statistics.ServiceFrequency.Title')"/>

          <HourPeakChart :dateRange="dateRange" @doneLoading="loadHourPeak = false,counterDistribution = true" :start-loading="loadHourPeak" :headerTitle="$t('Statistics.hourPeak')"/>
          <CounterPieChart :dateRange="dateRange" @doneLoading="loadCounterStats" :start-loading="counterDistribution" :headerTitle="$t('Statistics.counter')" />

          <CounterStatistics :start-loading="loadCounterStatistics" :data-range="dateRange" @doneLoading="loadCounterStatistics = false"></CounterStatistics>
  </vs-row>
</template>
<script>

import WaitingServiceTime from '../../components/statistics/WaitingServiceTime';
import FrequencyCharts from '../../components/statistics/FrequencyCharts';
import ServicePieChart from '../../components/statistics/ServicePieChart';
import ServiceFrequency from '../../components/statistics/ServiceFrequency';
import CustomersStats from '../../components/statistics/CustomersStats';
import { statisticsService } from "../../_services";
import BookingPaymentStats from '../../components/statistics/BookingPaymentStats';
import DatePicker from "vue2-datepicker";
import SmallStatBox from "@/components/statistics/SmallStatBox.vue";
import HourPeakChart from "@/components/statistics/HourPeakChart.vue";
import CounterPieChart from "@/components/statistics/CounterPieChart.vue";
import CounterStatistics from "@/components/statistics/CounterStatistics.vue";

export default {
  name: 'Statistics_new',
  data:() => ({
    filterType: 'MONTHLY',
    filterOptions: [{value: 'DAILY'}, {value: 'WEEKLY'}, {value: 'MONTHLY'}, {value: 'YEARLY'}],
    activeTab: 0,
    service_durations: [],
    service_durations_counter: [],
    loading_service_durations_counter: false,
    loading_service_durations: false,
    dateRange:null,
    avgTimeSpent:null,
    avgWaitingTime:null,
    totalRdv:null,
    totalServices:null,
    totalTickets:null,
    totalSms:null,
    loadServiceTime: false,
    loadFrequencyCharts: false,
    loadServicePieChart: false,
    loadServiceFrequency: false,
    loadHourPeak: false,
    counterDistribution: false,
    loadCounterStatistics: false,
    dateChanged: true,
  }),
  methods: {
    loadCounterStats() {
      this.counterDistribution = false;
      if(this.dateChanged) {
        this.loadCounterStatistics = true
        this.dateChanged = false;
      }
    },
    disableDates(date) {
      const currentMonth = new Date();
      currentMonth.setDate(1);
      return date > currentMonth;
    },
    changeFilterRanged(monthRange) {
      this.dateRange = monthRange;
      this.dateChanged = true;
      this.loadStats();
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      const day = date.getDate().toString().padStart(2, '0');
      return`${year}-${month}-${day}`;
    },
    getStartDate(month) {
      const [year, monthPart] = month.split('-');
      const startDate = new Date(`${year}-${monthPart}-01 00:00:00`);
      return this.formatDate(startDate);
    },
    getEndDate(month) {
      const [year, monthPart] = month.split('-');
      const lastDay = new Date(year, monthPart, 0);
      const endDate = new Date(`${year}-${monthPart}-${lastDay.getDate()} 23:59:59`);
      return this.formatDate(endDate);
    },
    loadStats() {
      this.totalTickets = null;
      this.totalServices = null;
      this.totalSms = null;
      this.totalRdv = null;
      this.avgWaitingTime = null;
      this.avgTimeSpent = null;
      const payload = {start: this.getStartDate(this.dateRange[0]), end:this.getEndDate(this.dateRange[1])}
      statisticsService.getTotalTickets(payload).then((data)=> {
        this.totalTickets = data.total;
      }).finally(()=> {
        statisticsService.getTotalServices(payload).then((data)=> {
          this.totalServices = data.total;
        }).finally(()=> {
          statisticsService.getTotalBookings(payload).then((data)=> {
            this.totalRdv = data.total;
          }).finally(()=> {
              statisticsService.getAvgWaitingTime(payload).then((data)=> {
                this.avgWaitingTime = data.avg;
              }).finally(()=> {
                statisticsService.getAvgServiceTime(payload).then((data)=> {
                  this.avgTimeSpent = data.avg;
                }).finally(()=> {
                  statisticsService.getTotalSms(payload).then((data)=> {
                    this.totalSms = data.total;
                  }).finally(()=> {
                  this.loadServiceTime = true;
                }).catch(()=> {
                  this.totalSms = "-1";
                })
              }).catch(()=> {
                this.avgTimeSpent = "-1";
              })
            }).catch(()=> {
              this.avgWaitingTime = "-1";
            })
          }).catch(()=> {
            this.totalRdv = "-1";
          })
        }).catch(()=> {
          this.totalServices = "-1";
        })
      }).catch(()=> {
        this.totalTickets = "-1";
      })
    },
    loadServices(monthRange) {
      this.loading_service_durations = true;
      this.loading_service_durations_counter = true;
      statisticsService.serviceDurations({periodical : "", start: this.getStartDate(monthRange[0]), end: this.getEndDate(monthRange[1])}).then((data)=>{
        this.service_durations= data.map((obj)=>{
          if(obj.translations && obj.translations!='{}'){
            obj.Operation = JSON.parse(obj.translations)[localStorage.getItem('Language')];
          }else{
            obj.Operation = obj.title
          }
          return obj
        })
      }).finally(()=> {

        this.loading_service_durations = false;
      })

      statisticsService.serviceDurationsPerCounter({periodical : "", start: this.getStartDate(monthRange[0]), end: this.getEndDate(monthRange[1])}).then((data) =>{
        this.service_durations_counter= data.map((obj)=>{
          if(obj.translations && obj.translations!='{}'){
            obj.Operation = JSON.parse(obj.translations)[localStorage.getItem('Language')];
          }else{
            obj.Operation = obj.title
          }
          return obj
        })
      }).finally(()=> {
        this.loading_service_durations_counter = false;
      })
    },
    setActive(active) {
      this.activeTab = active;
      if(active === 2) {
        this.loadServices(this.dateRange);
      }
    }
  },
  components:{
    CounterStatistics,
    CounterPieChart,
    HourPeakChart,
    SmallStatBox,
    WaitingServiceTime,
    FrequencyCharts,
    ServicePieChart,
    ServiceFrequency,
    CustomersStats,
    BookingPaymentStats,
    DatePicker
  },
  mounted(){
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    this.month = `${year}-${month}`;
    this.dateRange = [`${year}-${(currentDate.getMonth() + -1).toString().padStart(2, '0')}`, this.month];

    this.loadStats();
  }
}
</script>

<style scoped>
.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px; /* Adjust the height as needed */
  font-size: 20px;
  /* Add other styling as needed */
}
table{
  width: 100%;
  border: 1px solid #ddd;
}
.title{
  font-size: 20px;
  font-weight: bold;
  background: #008fc9;
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff;
  margin-bottom: 10px;
}
td, th, .vs-table-text{
  /* text-align: center !important; */
}
</style>